import { connect } from 'react-redux';
import type { PastProps } from '@/pages/CompanyReport/components/Past';
import Past from '@/pages/CompanyReport/components/Past';
import { getPastSectionSelector } from '@/pages/CompanyReport/components/Past/redux/selectors';
import { areStatesEqualCompanySection } from '@/pages/CompanyReport/redux/selectors';

const mapStateToProps = (
  state,
  ownProps: { companyId?: string; sectionNumber?: number }
): PastProps => {
  const past = getPastSectionSelector(state, ownProps);
  return {
    keyMetric: past.keyMetric,
    keyMetricTitle: past.keyMetricTitle,
    isFund: past.isFund,
    pastROA: past.pastROA,
    pastROE: past.pastROE,
    pastROCE1y: past.pastROCE1y,
    pastROCE3y: past.pastROCE3y,
    companyId: past.companyId,
    companyName: past.companyName,
    netIncomeGrowth1y: past.netIncomeGrowth1Y,
    netIncomeGrowth5y: past.netIncomeGrowth5Y,
    pastIndustryROE: past.pastIndustryROE,
    pastIndustryROA: past.pastIndustryROA,
    industryName: past.industryName,
    marketName: past.marketName,
    averageMarketGrowth1Y: past.averageMarketGrowth1Y,
    averageMarketGrowth5Y: past.averageMarketGrowth5Y,
    averageIndustryGrowth1Y: past.averageIndustryGrowth1Y,
    averageIndustryGrowth5Y: past.averageIndustryGrowth5Y,
    sectionNumber: ownProps.sectionNumber,
    netIncomeGrowth5YFormatted: past.netIncomeGrowth5YFormatted,
    averageIndustryGrowth5YFormatted: past.averageIndustryGrowth5YFormatted,
    averageMarketGrowth5YFormatted: past.averageMarketGrowth5YFormatted,
    netIncomeGrowth1YFormatted: past.netIncomeGrowth1YFormatted,
    averageIndustryGrowth1YFormatted: past.averageIndustryGrowth1YFormatted,
    averageMarketGrowth1YFormatted: past.averageMarketGrowth1YFormatted,
  };
};

export default connect(mapStateToProps, null, null, {
  areStatesEqual: areStatesEqualCompanySection,
})(Past);
